import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.t5h().i5k(), $completion));
  return SavedHttpCall().r5l(_this__u8e3s4.o5h_1, _this__u8e3s4.t5j(), _this__u8e3s4.t5h(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static r5l(client, request, response, responseBody) {
        var $this = this.s5j(client);
        $this.p5l_1 = responseBody;
        $this.q5h_1 = new (SavedHttpRequest())($this, request);
        $this.r5h_1 = new (SavedHttpResponse())($this, $this.p5l_1, response);
        checkContentLength(contentLength(response), fromInt($this.p5l_1.length), request.b5k());
        $this.q5l_1 = true;
        return $this;
      }
      v5j() {
        return this.q5l_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.s5l_1 = origin;
        this.t5l_1 = call;
      }
      a5k() {
        return this.t5l_1;
      }
      sv() {
        return this.s5l_1.sv();
      }
      b5k() {
        return this.s5l_1.b5k();
      }
      c5k() {
        return this.s5l_1.c5k();
      }
      u5j() {
        return this.s5l_1.u5j();
      }
      h2o() {
        return this.s5l_1.h2o();
      }
      n51() {
        return this.s5l_1.n51();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.u5l_1 = call;
        this.v5l_1 = body;
        this.w5l_1 = origin.j5k();
        this.x5l_1 = origin.k5k();
        this.y5l_1 = origin.l5k();
        this.z5l_1 = origin.m5k();
        this.a5m_1 = origin.n51();
        this.b5m_1 = origin.sv();
      }
      a5k() {
        return this.u5l_1;
      }
      j5k() {
        return this.w5l_1;
      }
      k5k() {
        return this.x5l_1;
      }
      l5k() {
        return this.y5l_1;
      }
      m5k() {
        return this.z5l_1;
      }
      n51() {
        return this.a5m_1;
      }
      sv() {
        return this.b5m_1;
      }
      i5k() {
        return ByteReadChannel(this.v5l_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
